import common from './common';

export default class utils {
	static collideAABB(r1, r2, scale = new PIXI.Point(1, 1)) {
		r1 = r1.getBounds();
		r2 = r2.getBounds();

		return !(r2.x > (r1.x + r1.width * scale.x) ||
			(r2.x + r2.width * scale.x) < r1.x ||
			r2.y > (r1.y + r1.height * scale.y) ||
			(r2.y + r2.height * scale.y) < r1.y);
	}

	static getDistance(o1, o2) {
		const px = Math.pow(o1.x - o2.x, 2);
		const py = Math.pow(o1.y - o2.y, 2);

		return Math.sqrt(px + py);
	}
}

/**
 * Client complained that Bulgarian/Russian words are too close together so we override the setter and add some more spaces.
 */
export function Text(text, params) {
	const o = new PIXI.extras.BitmapText(text, params);
	o.dirty = true;
	return o;
}

export function translate(key) {
	let str = key || '';

	if (str.length > 0) {
		const split = str.split('.');

		split.push(common.config.language || 'en');

		let i;
		let length;
		let t = common.config.strings;

		for (i = 0, length = split.length; i < length; ++i) {
			t = t[split[i]];
			if (!t) {
				break;
			}
		}
		i === split.length && (str = t);
	}

	return str;
}
